import React from "react";
import { Datagrid, List, TextField } from "react-admin";

export const getTypeVehicules = (props) => {
  return (
    <List {...props} exporter={false} sort={{ field: "id", order: "ASC" }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="label" />
        <TextField source="image" />
      </Datagrid>
    </List>
  );
};
